// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect#courseInterests{flex-wrap:wrap}.multiselect#courseInterests button{margin-right:8px !important}.block .row:first-child{flex-wrap:nowrap}#leadForm .multiselect{flex-wrap:wrap}#leadForm .multiselect button{margin-bottom:20px}\n", ""]);
// Exports
module.exports = exports;
